import Image from 'next/image';
import { useState, useEffect } from 'react';

import style from './SpinWidget.module.less';
import get from 'lodash/get';
import { Modal } from 'antd';
import LuckyWheelCampaign from '@components/LuckyWheelCampaign';
import { useFirstSpinCampaignLazyQuery } from '@hooks/giftCampaign/giftCampaign.gql.generated';
import { useAuth } from '@context/AuthContext';
import { WARRANTY_PAGE_URL } from '@utils/routeConstants';
import { useMaintenance } from '@context/MaintenanceContext';

function SpinWidget() {
  const { isLoggedIn } = useAuth();
  const [showIconSpin, setShowIconSpin] = useState(false);
  const [visible, setVisible] = useState(false);
  const [campaignId, setCampaignId] = useState<string>('');
  const { maintenance } = useMaintenance();

  const [fetchCampaignsWithoutCart] = useFirstSpinCampaignLazyQuery({
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
    onCompleted: res => {
      const firstCampaign = get(res, 'firstSpinCampaign', null);
      if (firstCampaign) {
        setCampaignId(firstCampaign.id);
        setShowIconSpin(true);
      } else {
        setCampaignId('');
        setShowIconSpin(false);
      }
    },
  });

  useEffect(() => {
    if (isLoggedIn) {
      fetchCampaignsWithoutCart();
    }
  }, []);

  function handleCancel() {
    setVisible(false);
    setCampaignId('');
    fetchCampaignsWithoutCart();
  }

  const isWarrantyPage = typeof window !== 'undefined' ? window.location.href.indexOf(WARRANTY_PAGE_URL) > -1 : false;

  return (
    <>
      {!maintenance && !isWarrantyPage && showIconSpin && (
        <>
          <div className={style.root} onClick={() => setVisible(true)}>
            <Image src="/images/lucky-wheel/spin-the-wheel.png" width={60} height={60} />
          </div>
          <Modal visible={visible} title="" footer={null} destroyOnClose width={800} onCancel={handleCancel}>
            <LuckyWheelCampaign id={campaignId} setVisible={setVisible} />
          </Modal>
        </>
      )}
    </>
  );
}

export default SpinWidget;
